export const ADMINISTRATOR_USER_SESSION_LOGS_INIT = 'ADMINISTRATOR_USER_SESSION_LOGS_INIT';
export const ADMINISTRATOR_USER_SESSION_LOGS_SUCCESS = 'ADMINISTRATOR_USER_SESSION_LOGS_SUCCESS';
export const ADMINISTRATOR_USER_SESSION_LOGS_ERROR = 'ADMINISTRATOR_USER_SESSION_LOGS_ERROR';